export enum TipoFormEnum {
  RICERCA = "RICERCA",
  //RICERCA_RECAPITI_LISTE = "RICERCA_RECAPITI_LISTE",
  CREAZIONE = "CREAZIONE",
  DETTAGLIO = "DETTAGLIO",
  MODIFICA = "MODIFICA",
  CLONA = "CLONA",
  //AGGIUNTA_RECAPITO = "AGGIUNTA_RECAPITO",
  VALIDAZIONE = "VALIDAZIONE"
}
